import type { FC } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import EyeOffIcon from 'mdi-react/EyeOffOutlineIcon'
import EyeIcon from 'mdi-react/EyeOutlineIcon'

import { useAppContext } from '@/App.context'
import { useTranslation } from '@/components/i18n/hooks'

const PasswordForm: FC = () => {
  const { whiteLabel } = useAppContext()
  const translate = useTranslation()

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Field name="password">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id="password"
          type={isPasswordVisible ? 'text' : 'password'}
          ariaLabel={translate('Password')}
          marginBottom={16}
          error={meta.error}
          touched={meta.touched}
          placeholder={translate('Enter your password')}
          RightElement={
            isPasswordVisible ? (
              <Button
                className="m-0 border-none bg-transparent p-0 text-gray-600 shadow-none hover:text-gray-700"
                onClick={() => setIsPasswordVisible(false)}
                Icon={<EyeOffIcon className="w-6" />}
                whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
              />
            ) : (
              <Button
                className="m-0 border-none bg-transparent p-0 text-gray-600 shadow-none hover:text-gray-700"
                Icon={<EyeIcon className="w-6" />}
                onClick={() => setIsPasswordVisible(true)}
                whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
              />
            )
          }
          whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
          {...field}
        />
      )}
    </Field>
  )
}

export default PasswordForm
